import styles from './virtual-scroll.module.css';

declare global {
    interface Window {
        Laravel: {
            debug: boolean;
        };
    }
}

class VirtualScrollApp {
    private container: HTMLElement | null;
    private items: HTMLElement[];
    private observer: IntersectionObserver;
    private bufferSize: number = 1; // 余裕を持たせるバッファサイズ
    private visibleItems: HTMLElement[] = [];

    constructor(itemClass: string, containerId?: string) {
        const container = containerId 
            ? document.getElementById(containerId)
            : null;

        this.container = container;
        this.items = Array.from((this.container ?? document).querySelectorAll(`.${itemClass}`));

        if (this.items.length === 0) {
            console.warn(`No items found with class "${itemClass}" inside container "${containerId}"`);
            return;
        }

        this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
            root: this.container,
            rootMargin: '0px',
            threshold: 0
        });
        this.init();
    }

    private init() {
        // // 最初の数個の要素だけを表示
        // this.updateVisibleItems();

        // 各要素を監視
        this.items.forEach(item => this.observer.observe(item));
    }

    private onIntersect(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            const element = entry.target as HTMLElement;
            const itemsArray = Array.from(this.items);
            const index = itemsArray.indexOf(element);
    
            if (entry.isIntersecting && index !== -1) {
                const start = Math.max(0, index - this.bufferSize);
                const end = Math.min(itemsArray.length - 1, index + this.bufferSize);
    
                for (let i = start; i <= end; i++) {
                    const item = itemsArray[i];
                    if (!this.visibleItems.includes(item)) {
                        this.visibleItems.push(item);
                    }
                    item.style.visibility = "visible"; // `display: none` ではなく `visibility: visible`
                }
                // const item = itemsArray[index];
                // if (!this.visibleItems.includes(item)) {
                //     this.visibleItems.push(item);
                // }
                // item.style.visibility = "visible"; // `display: none` ではなく `visibility: visible`
            } else {
                this.visibleItems = this.visibleItems.filter(el => el !== element);
                element.style.visibility = "hidden"; // `display: none` ではなく `visibility: hidden`
            }
        });
        if (window.Laravel?.debug==true) {
            console.log('visibled', this.visibleItems, window.Laravel.debug);
        }
    }
}


// // 仮想スクロールの初期化
// const data = Array.from({ length: 100000 }, (_, i) => `Item ${i + 1}`);
// new VirtualScroll("scroll-container", data);


// グローバルスコープに関数を追加（Bladeから呼び出すため）
// (window as any).renderMonthCalendar = renderMonthCalendar;

(window as any).VirtualScrollApp = VirtualScrollApp;
